import {
  Dialog,
  withStyles,
  DialogContent,
  DialogActions,
} from '@material-ui/core';

export const CustomDialogContent = withStyles(({ spacing }) => ({
  root: {
    padding: spacing(2),
    borderBottom: 0,
    borderTop: 0,
  },
}))(DialogContent);

export const CustomDialogActions = withStyles(() => ({
  root: {},
}))(DialogActions);

export const CustomDialog = withStyles(() => ({
  root: {},
}))(Dialog);
